import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'
import Fingertip from '../../assets/images/Fingertip_logo.svg'

function NotFound({ redirect }: { redirect: string }) {
  const navigate = useNavigate()

  const onBack = () => {
    navigate(redirect)
  }

  return (
    <Result
      title="Order not found"
      subTitle="Sorry, the page you are looking for does not exist."
      icon={<img src={Fingertip} alt="Not found" />}
      extra={
        <Button type="primary" size="large" onClick={onBack}>
          Back Home
        </Button>
      }
    />
  )
}

export default NotFound
